// extracted by mini-css-extract-plugin
export var container = "styles-module__container___ZkDp2";
export var newWaypointContainer = "styles-module__newWaypointContainer___vI2mT";
export var adminButtons = "styles-module__adminButtons___NLPGp";